import React from 'react';
import { tenancyApi } from '../../api';
import { useAuth } from '../../context/AuthContext';
import { Link } from '../../router/Router';
import { IconShield } from '../../components/ui/Icons';

export function AdminLoginPage() {
  const { portalMode } = useAuth();

  const handleGoogleAdminOAuth = () => {
    window.location.href = tenancyApi.getOAuthStartUrl('google');
  };

  return (
    <div className="min-h-screen flex flex-col justify-center bg-slate-900 py-12 px-4 sm:px-6 lg:px-8 text-white">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-indigo-500 text-white shadow-lg">
            <IconShield className="w-7 h-7" />
          </div>
        </div>
        <h1 className="mt-4 text-center text-2xl font-bold tracking-tight">
          Sync Platform Admin Console
        </h1>
        <p className="mt-1.5 text-center text-sm text-slate-400">
          Multi-tenant operations, customer impersonation, billing &amp; queue control
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="rounded-2xl border border-slate-800 bg-slate-800/90 p-6 sm:p-8 shadow-xl space-y-6">
          <button
            type="button"
            onClick={handleGoogleAdminOAuth}
            className="w-full flex items-center justify-center gap-3 rounded-xl bg-white px-4 py-3 text-sm font-semibold text-slate-900 shadow-xs hover:bg-slate-100 transition-colors"
          >
            <span>Sign in with Google Workspace OAuth</span>
          </button>

          {portalMode !== 'admin' && (
            <div className="border-t border-slate-700 pt-4 text-center">
              <Link to="/projects" className="text-xs font-medium text-indigo-400 hover:text-indigo-300">
                ← Switch to Customer Client Portal
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
